<template>
  <div>
    <p>
      The antenna's figure of merit (or gain to noise temperature)
      <katex-element expression="G/T" /> is given (in
      <katex-element expression="dB/K" />) by:
    </p>
    <p>
      <katex-element expression="G/T = G_r - L_{L,r} -  10\log{T_s}" />
    </p>
    <p>where:</p>
    <ul>
      <li>
        <katex-element expression="G_r" /> is the receiver antenna gain
        (<katex-element expression="dB" />);
      </li>
      <li>
        <katex-element expression="L_{L,r}" /> is the receiver transmission line
        loss (<katex-element expression="dB" />);
      </li>
      <li>
        <katex-element expression="T_s" /> is the system noise temperature
        (<katex-element expression="K" />).
      </li>
    </ul>
    <br />
  </div>
</template>

<script>
export default {
  name: 'tooltipEquationGT'
}
</script>
